let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2lq47")).then(() => parcelRequire('a8CW2'));